import { Component, OnInit, ViewChild } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { environment } from 'src/environments/environment';
import { CustomForms } from '../../forms/custom-forms';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxWindowComponent } from 'jqwidgets-ng/jqxwindow';
import { JqWidgets } from 'src/app/utils/jqWidgets';
import { Utils } from 'src/app/utils/utils';
import { NumberUtils } from 'src/app/utils/number-utils';
import { DateUtils } from 'src/app/utils/date-utils';
import * as xlsx from 'xlsx';
import { jqxNumberInputComponent } from 'jqwidgets-ng/jqxnumberinput';
import { HistoricoEnviosIdentificadorService } from 'src/app/services/historicoEnviosIdentificador/historico-envios-identificador.service';
import { HistoricoEnvioIdentiiicadorModel } from 'src/app/services/historicoEnviosIdentificador/models/historicoEnviosIdentificador.model';
import { DateIdentificacionModel } from 'src/app/services/cerraduras/models/dateIdentificacion';
import { PeriodoSelectComponent } from '../../periodo-select/periodo-select.component';
import { MainComponent } from '../../main/main.component';
import { ElementoModel } from 'src/app/services/elements/models/elem.model';
import { MapComponent, MapLatLng, MapMarker, MapModule, MapPolyline, MapPolylinePoint } from 'movisat-maps';
import { jqxCheckBoxComponent } from 'jqwidgets-ng/jqxcheckbox';
import { CerraduraModel } from 'src/app/services/cerraduras/models/cerradura.model';
import { CerraduraService } from 'src/app/services/cerraduras/cerradura.service';
import { ElementsService } from 'src/app/services/elements/elements.service';


@Component({
  selector: 'app-historico-envios-disp-identificador',
  templateUrl: './historico-envios-disp-identificador.component.html',
  styleUrls: ['./historico-envios-disp-identificador.component.css']
})
export class HistoricoEnviosDispIdentificadorComponent extends CustomForms implements OnInit {

  @ViewChild('periodoSelect') periodoSelect: PeriodoSelectComponent;
  @ViewChild('form') form: jqxWindowComponent;
  @ViewChild('grid') myGrid: jqxGridComponent;
  @ViewChild('currencyInput') currencyInput: jqxNumberInputComponent;
  @ViewChild('checkTodas') checkTodas: jqxCheckBoxComponent;
  @ViewChild('checkMasXmetros') checkMasXmetros: jqxCheckBoxComponent;

  private componentRef = null;
  public theme = environment.tema;

  // grid
  dataAdapter: any;
  source: any;
  public langGrid = JqWidgets.getLocalization('es');
  editrow: number = -1;
  columns = [
    { text: 'Id', columntype: 'textbox', filtertype: 'textbox', datafield: 'id', hidden: true },
    {
      text: this.translate('Fecha_envio'), columntype: 'textbox', filtertype: 'textbox', width: 130, datafield: 'fecha', cellsrenderer: this.renderRow, aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="text-align: left; margin-left: 4px;">' + AppComponent.translate('Total') + ': ' +
            NumberUtils.format(aggregates["Total"], 0) + '</div>';
        }
        return renderstring;
      }
    },
    {
      text: this.translate('Ns_movisat'), width: 160, columntype: 'textbox', filtertype: 'textbox', datafield: 'nsMovisat',
    },
    { text: this.translate('Num_identificaciones'), columntype: 'textbox', filtertype: 'textbox', datafield: 'numIdentificaciones', width: 100, cellsrenderer: this.numberrenderer, },
    { text: this.translate('Bateria'), columntype: 'textbox', filtertype: 'textbox', width: 60, datafield: 'bateriaPorcentaje', cellsrenderer: this.numberrenderer },
    { text: this.translate('Temperatura'), columntype: 'textbox', filtertype: 'textbox', datafield: 'temperatura', width: 80, cellsrenderer: this.numberrenderer },
    { text: this.translate('Coordenada_lat'), columntype: 'textbox', filtertype: 'textbox', datafield: 'lat', cellsrenderer: this.numberrenderer },
    { text: this.translate('Coordenada_lng'), columntype: 'textbox', filtertype: 'textbox', datafield: 'lng', cellsrenderer: this.numberrenderer },
    { text: this.translate('Metros'), columntype: 'textbox', filtertype: 'textbox', datafield: 'metros', width: 60, cellsrenderer: this.numberrendererDecimales },
    { text: this.translate('Elemento'), columntype: 'textbox', filtertype: 'textbox', datafield: 'nombreElemento', width: 100 },
    { text: this.translate('Marca'), columntype: 'textbox', filtertype: 'textbox', datafield: 'marca', width: 100 },
    { text: this.translate('Modelo'), columntype: 'textbox', filtertype: 'textbox', datafield: 'modelo', width: 100 },
    { text: this.translate('Matricula'), columntype: 'textbox', filtertype: 'textbox', datafield: 'matricula', width: 75 },
    { text: this.translate('Direccion'), columntype: 'textbox', filtertype: 'textbox', datafield: 'direccion', width: 100 },
    { text: this.translate('Municipio'), columntype: 'textbox', filtertype: 'textbox', datafield: 'municipio', width: 70 },
    { text: this.translate('Poblacion'), columntype: 'textbox', filtertype: 'textbox', datafield: 'poblacion', width: 70 },
    { text: this.translate('Observaciones'), columntype: 'textbox', filtertype: 'textbox', datafield: 'observaciones', menu: false, sortable: false, width: 80 },
  ];


  // identificaciones grid
  dataAdapterIdentificaciones: any;
  sourceIdentificaciones: any;
  public columnsIdentificacines = [
    { text: 'Id', columntype: 'textbox', filtertype: 'textbox', datafield: 'idCerradura', hidden: true },
    {
      text: this.translate('Fecha'), columntype: 'datetimeinput', filtertype: 'textbox', datafield: 'fecha', cellsrenderer: this.renderRow, aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="text-align: left; margin-left: 4px;">' + AppComponent.translate('Total') + ': ' +
            NumberUtils.format(aggregates["Total"], 0) + '</div>';
        }
        return renderstring;
      }
    },
    { text: this.translate('Ns_movisat'), columntype: 'textbox', filtertype: 'textbox', datafield: 'nsMovisat' },
    { text: this.translate('Ciudadano'), columntype: 'textbox', filtertype: 'textbox', datafield: 'nombreCiudadano', cellsrenderer: this.renderCiudadano },
    { text: this.translate('Aporte_residuo'), columntype: 'checkbox', filtertype: 'bool', datafield: 'aporteResiduo' },
    { text: this.translate('Apertura_tapa'), columntype: 'checkbox', filtertype: 'bool', datafield: 'aperturaTapa' },
    { text: this.translate('No_cerro_tapa'), columntype: 'checkbox', filtertype: 'bool', datafield: 'noCerroTapa' },
    {
      text: this.translate('Elemento'), columntype: 'textbox', filtertype: 'textbox', datafield: 'nombreElemento',
    },
    { text: this.translate('Marca'), columntype: 'textbox', filtertype: 'textbox', datafield: 'marca', },
    { text: this.translate('Modelo'), columntype: 'textbox', filtertype: 'textbox', datafield: 'modelo', },
    { text: this.translate('Ns_cerradura'), columntype: 'textbox', filtertype: 'textbox', datafield: 'nsCerradura', hidden: true },
    { text: this.translate('Observaciones'), columntype: 'textbox', filtertype: 'textbox', datafield: 'observaciones', },
    { text: this.translate('Matricula'), columntype: 'textbox', filtertype: 'textbox', datafield: 'matricula', },
    { text: this.translate('Tipo_identificacion'), columntype: 'textbox', filtertype: 'textbox', datafield: 'tipoIdentificacion', cellsrenderer: this.renderIdentificacion },
    { text: this.translate('Tipo_permiso'), columntype: 'textbox', filtertype: 'textbox', datafield: 'tipoPermiso', },
    { text: this.translate('Direccion'), columntype: 'textbox', filtertype: 'textbox', datafield: 'direccion' },
    { text: this.translate('Municipio'), columntype: 'textbox', filtertype: 'textbox', datafield: 'municipio', },
    { text: this.translate('Poblacion'), columntype: 'textbox', filtertype: 'textbox', datafield: 'poblacion', },
  ];

  // variables
  historicosEnviosIdentificador: HistoricoEnvioIdentiiicadorModel[] = [];
  dateIdentificacion: DateIdentificacionModel = new DateIdentificacionModel();
  dateFin = new Date();
  dateInicio = new Date();
  elemento: ElementoModel = new ElementoModel();
  elementos: ElementoModel[] = [];
  marker: MapMarker;
  markers: MapMarker[] = [];
  private map: MapComponent;
  cambiarNumberValue: boolean = false;
  cerraduras: CerraduraModel[] = [];
  private polyline: MapPolyline = null;
  private polylines: MapPolyline[] = [];

  constructor(private historicEnviosIdentificadorService: HistoricoEnviosIdentificadorService, private cerraduraService: CerraduraService, private elementsService: ElementsService) {
    super();
  }

  async ngOnInit() {
    this.map = MainComponent.getInstance().getMap();
    this.elementos = MainComponent.getInstance().elementsList;
    this.cerraduras = await this.cerraduraService.getCerraduras();
  }
  /**Inicializa el componente
  */
  init(componentRef: any) {
    this.componentRef = componentRef;
  }

  ngAfterViewInit(): void {
    this.addCustomForm(this.form);
    this.form.setTitle(AppComponent.translate('Historico_envios_dispositivo_identificador'));
    this.valuesByDefault();
    this.gethistoricoEnviosIdentificador();
  }


  valuesByDefault() {
    this.dateInicio.setHours(0, 0, 0);
    this.dateFin.setHours(23, 59, 59);
    this.dateIdentificacion.Desde = this.dateInicio;
    this.dateIdentificacion.Hasta = this.dateFin;
    this.currencyInput.value(50);
    this.currencyInput.disabled(true);
  }

  async gethistoricoEnviosIdentificador() {
    this.historicosEnviosIdentificador = await this.historicEnviosIdentificadorService.getHistoricosEnviosIdentificador(this.dateIdentificacion);

    if (this.historicosEnviosIdentificador.length > 0) {
      this.source = {
        localdata: this.historicosEnviosIdentificador,
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'number', map: 'id' },
          { name: 'fecha', type: 'date', map: 'fechaEnvio' },
          { name: 'nsMovisat', type: 'string', map: 'nsMovisat' },
          { name: 'numIdentificaciones', type: 'number', map: 'cantidad' },
          { name: 'bateriaPorcentaje', type: 'number', map: 'bateriaPorcentaje' },
          { name: 'temperatura', type: 'number', map: 'temperatura' },
          { name: 'lat', type: 'string', map: 'lat' },
          { name: 'lng', type: 'string', map: 'lng' },
          { name: 'latElemento', type: 'string', map: 'latElemento' },
          { name: 'lngElemento', type: 'string', map: 'lngElemento' },
          { name: 'idElemento', type: 'number', map: 'idElemento' },
          { name: 'metros', type: 'number', map: 'metros' },
          { name: 'nombreElemento', type: 'string', map: 'nombreElemento' },
          { name: 'marca', type: 'string', map: 'marcaElemento' },
          { name: 'modelo', type: 'string', map: 'modeloElemento' },
          { name: 'matricula', type: 'string', map: 'matriculaElemento' },
          { name: 'direccion', type: 'string', map: 'direccionElemento' },
          { name: 'municipio', type: 'string', map: 'municipioElemento' },
          { name: 'poblacion', type: 'string', map: 'poblacionElemento' },
          { name: 'observaciones', type: 'string', map: 'observacionesElemento' },
        ],
      };
      this.dataAdapter = new jqx.dataAdapter(this.source);
      this.dataAdapter.dataBind();
      this.myGrid.source(this.dataAdapter);
      this.myGrid.refresh();
    }
  }

  getDetalleIdentificaciones(idEnvio: number) {
    // Buscar el objeto que coincide con el idEnvio
    const foundObject = this.historicosEnviosIdentificador.find(x => x.id == idEnvio);
    this.sourceIdentificaciones = {
      localdata: foundObject.Detalle,
      datatype: 'json',
      datafields: [
        { name: 'idCerradura', type: 'number', map: 'idCerradura' },
        { name: 'idTarjeta', type: 'number', map: 'idTarjeta' },
        { name: 'fecha', type: 'date', map: 'fecha' },
        { name: 'nsMovisat', type: 'string', map: 'nsTarjeta' },
        { name: 'nombreCiudadano', type: 'string', map: 'nombreCiudadano' },
        { name: 'aporteResiduo', type: 'boolean', map: 'aporte' },
        { name: 'aperturaTapa', type: 'boolean', map: 'aperturaTapa' },
        { name: 'noCerroTapa', type: 'boolean', map: 'noCerroTapa' },
        //{ name: 'nsCerradura', type: 'string', map: 'nsCerradura' },
        { name: 'observaciones', type: 'string', map: 'observacionesElemento' },
        { name: 'matricula', type: 'string', map: 'matriculaElemento' },
        { name: 'tipoIdentificacion', type: 'string', map: 'tipoTag' },
        { name: 'tipoPermiso', type: 'string', map: 'tipoPermiso' },
        { name: 'marca', type: 'string', map: 'marcaElemento' },
        { name: 'modelo', type: 'string', map: 'modeloElemento' },
        { name: 'nombreElemento', type: 'string', map: 'nombreElemento' },
        { name: 'direccion', type: 'string', map: 'direccionElemento' },
        { name: 'municipio', type: 'string', map: 'municipioElemento' },
        { name: 'poblacion', type: 'string', map: 'poblacionElemento' },
      ],
    };

    this.dataAdapterIdentificaciones = new jqx.dataAdapter(this.sourceIdentificaciones);
    this.dataAdapterIdentificaciones.dataBind();
  }


  // asigno las fechas del periodo seleccionado
  onAceptar(event: any) {
    this.dateInicio = this.periodoSelect.getFechaIni();
    this.dateFin = this.periodoSelect.getFechaFin();
    this.dateIdentificacion.Desde = this.dateInicio;
    this.dateIdentificacion.Hasta = this.dateFin;
    this.gethistoricoEnviosIdentificador();
    setTimeout(() => {
      if (this.cambiarNumberValue) {
        this.cambiarNumberValue = false;
        let valor: number = this.currencyInput.val();
        let datos = this.historicosEnviosIdentificador.filter(x => x.metros >= valor);
        this.source.localdata = datos;
      } else {
        this.source.localdata = this.historicosEnviosIdentificador;
      }
      this.dataAdapter.dataBind();
      this.myGrid.source(this.dataAdapter);
      this.myGrid.updatebounddata();
    }, 200);
  }

  onClose() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }

    if (this.markers.length > 0) {
      this.markers.forEach(element => {
        this.map.removeMarker(element);
      });
      this.markers = [];
    }
  }
  // Para traducir los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  renderRow(row: number, columnfield: string, value: any,
    defaulthtml: string, columnproperties: any, rowdata: any): string {
    if (value) {
      let date = new Date(value);
      return '<div style="margin-right: 4px;">' + DateUtils.formatDateTimeShort(date, true) + '</div>';
    }
  }

  numberrenderer(
    row: number,
    columnfield: string,
    value: any,
    defaulthtml: string,
    columnproperties: any,
    rowdata: any
  ): string {
    if (columnfield == 'bateriaPorcentaje') {
      return (
        '<div style="margin-right: 4px; margin-top: 5px; text-align: right">' +
        NumberUtils.format(value, 0) +
        '%</div>'
      );
    } else if (columnfield === 'temperatura') {
      return (
        '<div style="margin-right: 4px; margin-top: 5px; text-align: right">' +
        NumberUtils.format(value, 0) +
        'º</div>'
      );
    } else {
      return '<div style="margin-right: 4px; margin-top: 5px; text-align: right">' + NumberUtils.format(value, 0) + '</div>';
    }
  }

  numberrendererDecimales(
    row: number,
    columnfield: string,
    value: any,
    defaulthtml: string,
    columnproperties: any,
    rowdata: any
  ): string {

    return (
      '<div style="margin-right: 4px; margin-top: 5px; text-align: right;">' +
      NumberUtils.format(value, 2) +
      '</div>'
    );
  }

  renderText(row: number, columnfield: string, value: any, defaulthtml: string, columnproperties: any, rowdata: any): string {
    if (rowdata.idElemento == 0 || rowdata.idElemento == null) {
      return '';
    } else if (rowdata.nombreElemento == null || rowdata.nsCerradura == null) {
      return '';
    } else {
      return '<div style="margin-right: 4px; margin-top: 5px;">' + rowdata.nombreElemento + '</div>';
    }
  }


  renderIdentificacion(row: number, columnfield: string, value: any,
    defaulthtml: string, columnproperties: any, rowdata: any): string {
    if (value == 0) {
      return '<div style="margin-left: 4px; margin-top: 8px;">NFC</div>';
    } else {
      return '<div style="margin-left: 4px; margin-top: 8px;">BT</div>';
    }
  }

  renderCiudadano(row: number, columnfield: string, value: any,
    defaulthtml: string, columnproperties: any, rowdata: any): string {
    // si el idElemento es 0, mostra el nsCerradura
    if (rowdata.nombreCiudadano == null) {
      return '';
    }
  }

  initrowdetails = async (index: number, parentElement: any, gridElement: any, datarecord: any): Promise<void> => {
    if (datarecord == null) {
      return;
    }

    let id = await datarecord.id;
    let container = parentElement.children[0];
    let subGridId = 'gridIdentificaciones' + id;

    container.id = subGridId;
    this.getDetalleIdentificaciones(id);

    let gridIdentificaciones = jqwidgets.createInstance('#' + subGridId, 'jqxGrid', {
      width: '98%',
      height: 200,
      source: this.dataAdapterIdentificaciones,
      theme: this.theme,
      columns: this.columnsIdentificacines,
      localization: this.langGrid,
      sortable: true,
      autoshowfiltericon: true,
      columnsresize: true,
      columnsheight: 20,
      rowsheight: 20,
      statusbarheight: 20,
      editable: false,
      showaggregates: true,
    });
    gridIdentificaciones.refresh();
    Utils.renderSizeGrid(gridIdentificaciones);
  }

  rowdetailstemplate: any = {
    rowdetails: '<div style="margin: 10px;"></div>',
    rowdetailsheight: 220,
    rowdetailshidden: true
  };

  onRowdoubleclick(event: any): void {
    // Elimino los marcadores del mapa
    if (this.markers.length > 0) {
      this.markers.forEach(element => {
        this.map.removeMarker(element);
      });
      this.markers = [];
    }

    // muestro el elemento en el mapa
    let foundEnvio: HistoricoEnvioIdentiiicadorModel = this.historicosEnviosIdentificador.find(x => x.id == event.args.row.bounddata.id);
    this.elemento = this.elementos.find(x => x.Id == foundEnvio.idElemento);
    // busco la cerradura que coincide con el idElemento de foundEnvio
    let cerradura: CerraduraModel = this.cerraduras.find(x => x.idElemento == foundEnvio.idElemento);
    this.showEnviosIdentificacionesMap(cerradura, foundEnvio);
    this.polyline = this.addPolyline();
    if (this.polyline) {
      this.map.addPolylinePoint(this.polyline, {
        dataModel: this,
        content: '',
        position: new MapLatLng(foundEnvio.lat, foundEnvio.lng)
      });
    }
  }

  showEnviosIdentificacionesMap(cerradura: CerraduraModel, foundEnvio: HistoricoEnvioIdentiiicadorModel): void {

    let points: MapPolylinePoint[] = [];
    // Verificar si las coordenadas del objeto foundEnvio del elemento existen
    if (foundEnvio.latElemento != 0 || foundEnvio.lngElemento != 0) {
      let icono: string = 'data:image/png;base64,' + this.elemento.Equipamiento.Icono;
      let elementoMarker = this.addMarker(new MapLatLng(foundEnvio.latElemento, foundEnvio.lngElemento), icono);
      points.push(new MapPolylinePoint(1, '', new MapLatLng(foundEnvio.latElemento, foundEnvio.lngElemento))); // Agregar el punto al arreglo
    }

    // Verificar si las coordenadas del objeto cerradura existen
    if (cerradura && (cerradura.lat != 0 || cerradura.lng != 0)) {
      let icono: string = 'data:image/png;base64,' + this.elemento.Equipamiento.Icono;
      let cerraduraMarker = this.addMarker(new MapLatLng(cerradura.lat, cerradura.lng), icono);
      points.push(new MapPolylinePoint(2, '', new MapLatLng(cerradura.lat, cerradura.lng))); // Agregar el punto al arreglo
    }

    if (!cerradura && !foundEnvio.latElemento && !foundEnvio.lngElemento) {
      MainComponent.getInstance().showError('ATENCION', 'No_existen_coordenadas', 2000);
    }
    foundEnvio.lat = 37.98644080567557;
    foundEnvio.lng = -1.1416920530665142;

    // Verifico si las coordenadas del objeto foundEnvio existen
    if (foundEnvio.lat != 0 || foundEnvio.lng != 0) {
      let icono: string = 'assets/images/identificacion-inteligente.png';
      let marker = this.addMarker(new MapLatLng(foundEnvio.lat, foundEnvio.lng), icono);
      points.push(new MapPolylinePoint(3, '', new MapLatLng(foundEnvio.lat, foundEnvio.lng))); // Agregar el punto al arreglo
      marker.content = '<div style="margin: 10px;">' + this.translate('Ns_movisat') + '<br>' + foundEnvio.nsMovisat + '</div>';
    }

    if (points.length >= 2) {
      const polyline = this.map.addPolyline({
        color: 'ff0000', // Puedes cambiar el color de la línea si lo deseas
        weight: 3,
        opacity: 0.7,
        clickable: false, // La línea no será interactiva
        points: points.map(point => point.point) // Extraer las coordenadas de los puntos y pasarlas al arreglo
      });
      this.polylines.push(polyline); // Agregar la línea al arreglo de polylines
    }

    // Animar los marcadores y colapsar el formulario
    if (this.markers.length > 0) {
      this.markers.forEach(element => element.animate(2000));
      this.form.collapse();
    }

  }

  // Método para crear un marcador y agregarlo a la lista de marcadores
  addMarker(location: MapLatLng, icono: string): any {
    let marker = this.createMarkers(location, icono);
    this.markers.push(marker);
    return marker;
  }

  createMarkers(position: MapLatLng, icono: string): MapMarker {
    return this.map.addMarker({
      dataModel: this,
      title: '',
      content: '',
      position: position,
      icon: icono,
      zIndex: 999,
      drag: true,
      visible: true
    });
  }

  // añado una polylinea al mapa entre dos puntos (inicio y fin)
  addPolyline(): MapPolyline {
    const polyline = this.map.addPolyline({
      color: 'ff333c',
      weight: 7,
      opacity: 0.7,
      clickable: true
    });
    this.polylines.push(polyline);
    return polyline;
  }

  changeTodos(event: any) {
    if (event.args.checked) {
      this.checkMasXmetros.checked(false);
      this.currencyInput.disabled(true);
      this.currencyInput.val(50);
      // Muestro todos los envios
      this.source.localdata = this.historicosEnviosIdentificador;
      this.dataAdapter.dataBind();
      this.myGrid.source(this.dataAdapter);
      this.myGrid.updatebounddata();
    }
  }

  changeMasXmetros(event: any) {
    if (event.args.checked) {
      this.checkTodas.checked(false);
      this.currencyInput.disabled(false);
      this.cambiarNumberValue = true;
    }
  }

  valueChangedNumber(event: any) {
    this.cambiarNumberValue = true;
  }

  onExportar(event: any) {
    const json = JSON.parse(JSON.stringify(this.myGrid.getdisplayrows()));
    const ws: xlsx.WorkSheet = xlsx.utils.json_to_sheet(json);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, 'Hoja1');
    xlsx.writeFile(wb, DateUtils.formatDateAMDhms(new Date()) + '_InformeHistoricosEnviosIdentificaciones.xlsx');
  }

}
